export interface GradingCompany {
  value: string;
  label: string;
  shortName: string;
  maxGrade: number;
  supportsHalfGrades: boolean;
  premiumGradeLabel?: string; // e.g., "Black Label", "Pristine" for grades above standard 10
}

export const GRADING_COMPANIES: GradingCompany[] = [
  { value: 'psa', label: 'PSA (Professional Sports Authenticator)', shortName: 'PSA', maxGrade: 10, supportsHalfGrades: false },
  { value: 'bgs', label: 'BGS (Beckett Grading Services)', shortName: 'BGS', maxGrade: 10, supportsHalfGrades: true, premiumGradeLabel: 'Black Label' },
  { value: 'cgc', label: 'CGC (Certified Guaranty Company)', shortName: 'CGC', maxGrade: 10, supportsHalfGrades: true, premiumGradeLabel: 'Pristine' },
  { value: 'tag', label: 'TAG Grading', shortName: 'TAG', maxGrade: 10, supportsHalfGrades: true },
  { value: 'ace', label: 'ACE Grading', shortName: 'ACE', maxGrade: 10, supportsHalfGrades: true },
  { value: 'sgc', label: 'SGC (Sportscard Guaranty)', shortName: 'SGC', maxGrade: 10, supportsHalfGrades: true, premiumGradeLabel: 'Pristine' },
  { value: 'ags', label: 'AGS (Authentic Grading)', shortName: 'AGS', maxGrade: 10, supportsHalfGrades: true },
  { value: 'ksa', label: 'KSA Certification', shortName: 'KSA', maxGrade: 10, supportsHalfGrades: false },
  { value: 'arena', label: 'Arena Club', shortName: 'Arena', maxGrade: 10, supportsHalfGrades: true },
  { value: 'ccc', label: 'CCC Grading', shortName: 'CCC', maxGrade: 10, supportsHalfGrades: true },
  { value: 'mnt', label: 'MNT Grading', shortName: 'MNT', maxGrade: 10, supportsHalfGrades: true },
  { value: 'gma', label: 'GMA Grading', shortName: 'GMA', maxGrade: 10, supportsHalfGrades: true },
  { value: 'hga', label: 'HGA (Hybrid Grading Approach)', shortName: 'HGA', maxGrade: 10, supportsHalfGrades: true },
  { value: 'csg', label: 'CSG (Certified Sports Guaranty)', shortName: 'CSG', maxGrade: 10, supportsHalfGrades: true },
  { value: 'getgraded', label: 'Get Graded', shortName: 'GetGraded', maxGrade: 10, supportsHalfGrades: true },
  { value: 'sas', label: 'SAS Grading', shortName: 'SAS', maxGrade: 10, supportsHalfGrades: true },
];

export const GRADING_COMPANY_MAP = new Map(
  GRADING_COMPANIES.map(company => [company.value, company])
);

export function findGradingCompany(searchTerm: string): GradingCompany[] {
  const term = searchTerm.toLowerCase();
  return GRADING_COMPANIES.filter(
    company =>
      company.value.includes(term) ||
      company.label.toLowerCase().includes(term) ||
      company.shortName.toLowerCase().includes(term)
  );
}

/**
 * Returns the canonical display name for a grading company value.
 * Uses the registered shortName (already uppercase, e.g. "PSA") when known,
 * otherwise upper-cases each word of the raw value so "psa" becomes "PSA".
 */
export function formatGradingCompany(value: string | null | undefined): string {
  if (!value) return '';
  const normalized = String(value).toLowerCase().trim();
  const company = GRADING_COMPANY_MAP.get(normalized);
  if (company) return company.shortName;
  // Fallback: uppercase each word (e.g. "psa japan" -> "PSA Japan")
  return normalized
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
